module.exports = __webpack_public_path__ + "img/logo_purple.30d4de3.svg";